export const SET_EMAILS = 'SET_EMAILS';
export const CLEAR_EMAILS = 'CLEAR_EMAILS';
export const SET_STORED_EMAILS = 'SET_STORED_EMAILS';

export const clearEmails = {
  type: CLEAR_EMAILS,
}

export const setEmails = (data) => {
  return {
    type: SET_EMAILS,
    payload: data,
  }
}

export const setStoredEmails = (data) => {
  return {
    type: SET_STORED_EMAILS,
    payload: data,
  }
}